module.exports = __webpack_public_path__ + "img/ko_img1.af4c188b.png";